export default "__VITE_ASSET__CWd6gabB__"